import { render, staticRenderFns } from "./BullDeworming.vue?vue&type=template&id=6c19b4a4&scoped=true&"
import script from "./BullDeworming.vue?vue&type=script&lang=js&"
export * from "./BullDeworming.vue?vue&type=script&lang=js&"
import style0 from "./BullDeworming.vue?vue&type=style&index=0&id=6c19b4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19b4a4",
  null
  
)

export default component.exports